var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeposit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "reply"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.707 3.29279C7.89447 3.48031 7.99979 3.73462 7.99979 3.99979C7.99979 4.26495 7.89447 4.51926 7.707 4.70679L5.414 6.99979H11C12.8565 6.99979 14.637 7.73728 15.9497 9.05004C17.2625 10.3628 18 12.1433 18 13.9998V15.9998C18 16.265 17.8946 16.5194 17.7071 16.7069C17.5196 16.8944 17.2652 16.9998 17 16.9998C16.7348 16.9998 16.4804 16.8944 16.2929 16.7069C16.1054 16.5194 16 16.265 16 15.9998V13.9998C16 12.6737 15.4732 11.4019 14.5355 10.4643C13.5979 9.52657 12.3261 8.99979 11 8.99979H5.414L7.707 11.2928C7.80251 11.385 7.87869 11.4954 7.9311 11.6174C7.98351 11.7394 8.0111 11.8706 8.01225 12.0034C8.0134 12.1362 7.9881 12.2678 7.93782 12.3907C7.88754 12.5136 7.81329 12.6253 7.7194 12.7192C7.6255 12.8131 7.51385 12.8873 7.39095 12.9376C7.26806 12.9879 7.13638 13.0132 7.0036 13.012C6.87082 13.0109 6.7396 12.9833 6.6176 12.9309C6.49559 12.8785 6.38525 12.8023 6.293 12.7068L2.293 8.70679C2.10553 8.51926 2.00021 8.26495 2.00021 7.99979C2.00021 7.73462 2.10553 7.48031 2.293 7.29279L6.293 3.29279C6.48053 3.10532 6.73484 3 7 3C7.26516 3 7.51947 3.10532 7.707 3.29279Z",
    fill: "#743BBC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeposit);
export default __webpack_public_path__ + "static/media/deposit.f61d4f477586d34f11863911c1cff4be.svg";
export { ForwardRef as ReactComponent };